<template>
  <div class="gestion-tareas-container p-4">
    <div class="mb-3">
      <vs-button icon="arrow_back" size="small" type="border" @click="$router.push('/actividades-control')">Volver</vs-button>
    </div>
    <vx-card title="Gestión de Tareas">
      <!-- Filtros -->
      <div class="flex flex-wrap items-center mb-6 gap-3">
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Fecha Desde</label>
          <flat-pickr v-model="filtros.fecha_desde" placeholder="Seleccionar" />
        </div>
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Fecha Hasta</label>
          <flat-pickr v-model="filtros.fecha_hasta" placeholder="Seleccionar" />
        </div>
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Estado</label>
          <v-select
            v-model="filtros.estado"
            :options="opcionesEstado"
            :reduce="opt => opt.value"
            placeholder="Todos"
            class="w-full"
          />
        </div>
        <div class="w-full md:w-1/4">
          <label class="text-sm font-semibold">Departamento</label>
          <v-select
            v-model="filtros.tdp_id"
            :options="departamentos"
            :reduce="opt => opt.tdp_id"
            label="tdp_nombre"
            placeholder="Todos"
            class="w-full"
          />
        </div>
        <div class="w-full md:w-1/6">
          <label class="text-sm font-semibold">&nbsp;</label>
          <vs-button color="primary" @click="cargarTareas" class="w-full">Filtrar</vs-button>
        </div>
      </div>

      <!-- Tabla -->
      <vs-table :data="tareasFiltradas" stripe :pagination="pagination" :search="search">
        <template slot="thead">
          <vs-th>Fecha</vs-th>
          <vs-th>Empleado</vs-th>
          <vs-th>Departamento</vs-th>
          <vs-th>Categoría</vs-th>
          <vs-th>Descripción</vs-th>
          <vs-th>Horas</vs-th>
          <vs-th>Estado</vs-th>
          <vs-th>Validador</vs-th>
          <vs-th>Acciones</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(tarea, index) in data" :key="index">
            <vs-td>{{ formatearFecha(tarea.fecha_tarea) }}</vs-td>
            <vs-td>
              <p class="font-semibold">{{ tarea.empleado && tarea.empleado.nombres }} {{ tarea.empleado && tarea.empleado.apellidos }}</p>
            </vs-td>
            <vs-td>
              <vs-chip :color="getColorDepartamento(tarea.departamento && tarea.departamento.tdp_id)">
                {{ (tarea.departamento && (tarea.departamento.tdp_nombre || tarea.departamento.tdp_iniciales)) || '—' }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <vs-chip color="warning" size="small">{{ tarea.categoria && tarea.categoria.cat_nombre }}</vs-chip>
            </vs-td>
            <vs-td class="text-truncate" style="max-width: 300px;">{{ tarea.descripcion }}</vs-td>
            <vs-td>{{ tarea.horas_dedicadas }} h</vs-td>
            <vs-td>
              <vs-chip :color="getColorEstado(tarea.estado)" size="small">
                {{ getLabelEstado(tarea.estado) }}
              </vs-chip>
            </vs-td>
            <vs-td v-if="tarea.validador">
              {{ tarea.validador.nombres }} {{ tarea.validador.apellidos }}
            </vs-td>
            <vs-td v-else>—</vs-td>
            <vs-td>
              <div class="flex gap-2">
                <vs-button size="small" icon="edit" @click="editarTarea(tarea)" color="primary" type="flat" />
                <vs-button size="small" icon="delete" @click="eliminarTarea(tarea)" color="danger" type="flat" />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- Modal Editar -->
      <vs-popup title="Editar Tarea" :active.sync="modalEditar">
        <div v-if="tareaEditando" class="p-4">
          <div class="mb-4">
            <label class="text-sm font-semibold">Descripción</label>
            <vs-input v-model="tareaEditando.descripcion" class="w-full" />
          </div>
          <div class="flex gap-4 mb-4">
            <div class="w-1/2">
              <label class="text-sm font-semibold">Horas</label>
              <vs-input v-model="tareaEditando.horas_dedicadas" type="number" step="0.5" min="0.5" class="w-full" />
            </div>
            <div class="w-1/2">
              <label class="text-sm font-semibold">Estado</label>
              <v-select
                v-model="tareaEditando.estado"
                :options="opcionesEstadoEdit"
                :reduce="opt => opt.value"
                class="w-full"
              />
            </div>
          </div>
          <div class="flex justify-end gap-2">
            <vs-button @click="modalEditar = false" color="warning">Cancelar</vs-button>
            <vs-button @click="guardarEdicion" color="success">Guardar</vs-button>
          </div>
        </div>
      </vs-popup>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: 'GestionTareas',
  data() {
    return {
      tareas: [],
      filtros: {
        fecha_desde: null,
        fecha_hasta: null,
        estado: null,
        tdp_id: null
      },
      departamentos: [],
      opcionesEstado: [
        { label: 'Pendiente', value: 'pendiente' },
        { label: 'En revisión', value: 'en_revision' },
        { label: 'Validada', value: 'validada' },
        { label: 'Rechazada', value: 'rechazada' }
      ],
      opcionesEstadoEdit: [
        { label: 'Pendiente', value: 'pendiente' },
        { label: 'En revisión', value: 'en_revision' },
        { label: 'Validada', value: 'validada' },
        { label: 'Rechazada', value: 'rechazada' }
      ],
      pagination: { page: 1, perPage: 15, total: 0 },
      search: '',
      modalEditar: false,
      tareaEditando: null
    }
  },
  computed: {
    tareasFiltradas() {
      return this.tareas
    }
  },
  mounted() {
    this.cargarDepartamentos()
    this.cargarTareas()
  },
  methods: {
    async cargarDepartamentos() {
      try {
        const res = await this.$http.get(this.$server_url + 'actividades-control/departamentos')
        this.departamentos = res.data
      } catch (e) {
        console.error(e)
      }
    },
    async cargarTareas() {
      try {
        const params = { ...this.filtros }
        if (params.fecha_desde) params.fecha_desde = this.$moment(params.fecha_desde).format('YYYY-MM-DD')
        if (params.fecha_hasta) params.fecha_hasta = this.$moment(params.fecha_hasta).format('YYYY-MM-DD')
        const res = await this.$http.get(this.$server_url + 'actividades-control/tareas', { params })
        this.tareas = res.data
        this.pagination.total = res.data.length
      } catch (e) {
        console.error(e)
        this.$vs.notify({ title: 'Error', text: 'No se pudieron cargar las tareas', color: 'danger' })
      }
    },
    getColorEstado(estado) {
      const colores = { pendiente: 'warning', en_revision: 'primary', validada: 'success', rechazada: 'danger' }
      return colores[estado] || 'dark'
    },
    getLabelEstado(estado) {
      const labels = { pendiente: 'Pendiente', en_revision: 'En revisión', validada: 'Validada', rechazada: 'Rechazada' }
      return labels[estado] || estado
    },
    getColorDepartamento(id) {
      const colores = ['primary', 'success', 'warning', 'danger', 'dark', 'info']
      return colores[(id || 0) % colores.length]
    },
    formatearFecha(f) {
      return f ? this.$moment(f).format('DD/MM/YYYY') : '—'
    },
    editarTarea(tarea) {
      this.tareaEditando = { ...tarea }
      this.modalEditar = true
    },
    async guardarEdicion() {
      try {
        await this.$http.put(this.$server_url + `actividades-control/tareas/${this.tareaEditando.id}`, this.tareaEditando)
        this.$vs.notify({ title: 'Éxito', text: 'Tarea actualizada', color: 'success' })
        this.modalEditar = false
        this.cargarTareas()
      } catch (e) {
        console.error(e)
        this.$vs.notify({ title: 'Error', text: 'No se pudo actualizar', color: 'danger' })
      }
    },
    async eliminarTarea(tarea) {
      if (!await this.$vs.confirm('¿Eliminar esta tarea?')) return
      try {
        await this.$http.delete(this.$server_url + `actividades-control/tareas/${tarea.id}`)
        this.$vs.notify({ title: 'Eliminado', text: 'Tarea eliminada', color: 'success' })
        this.cargarTareas()
      } catch (e) {
        this.$vs.notify({ title: 'Error', text: 'No se pudo eliminar', color: 'danger' })
      }
    }
  }
}
</script>

<style scoped>
.text-truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
</style>